import React, { FunctionComponent } from "react";
import Dialog from "@bg/shared/lib/components/Dialog";
import { Typography } from "@material-ui/core";

interface VerifyOrderDetailsDialogProps {
  openDialog: boolean;
  submitterName: string;
  physicianName: string;
  date: string;
  handleConfirm: () => void;
  handleCancel: () => void;
  submitterNameId?: number;
  physicianNameId?: number;
}

const VerifyOrderDetailsDialog: FunctionComponent<VerifyOrderDetailsDialogProps> = ({
  openDialog,
  submitterName,
  physicianName,
  date,
  handleConfirm,
  handleCancel,
  submitterNameId,
  physicianNameId,
}) => {

  const isSamePerson =
    submitterNameId &&
    physicianNameId &&
    submitterNameId === physicianNameId;

  const dialogContent = () => (
    <Typography>
      {isSamePerson ? (
        <>
          I confirm that this order is being placed by{" "}
          <strong>{physicianName}</strong> on <strong>{date}</strong>.
        </>
      ) : (
        <>
          I confirm that this order is being placed by{" "}
          <strong>{submitterName}</strong> on behalf of{" "}
          <strong>{physicianName}</strong> on <strong>{date}</strong>.
        </>
      )}
    </Typography>
  );

  return (
    <Dialog
      dialogTitle="Verify Order Details"
      dialogBody={dialogContent()}
      openDialog={openDialog}
      yesText="Confirm"
      noText="Cancel"
      handleYesAnswer={handleConfirm}
      handleNoAnswer={handleCancel}
      maxWidth="sm"
    />
  );
};

export default VerifyOrderDetailsDialog;
